// @ts-nocheck
import constants from "@store/constants";
import { getBlogSimilarArticles, GetBlogSimilarArticlesApiParameter } from "@store/Framework/Services/BlogService";
import { BlogSimilarArticlesCollectionModel } from "@store/Framework/Types/ApiModels";
import { ApiHandler, createHandlerChainRunner } from "@toolkit/Modules/client-framework/HandlerCreator";
import { getContextData } from "@toolkit/Modules/client-framework/Store/Data/Pages/PagesActionCreators";

type HandlerType = ApiHandler<GetBlogSimilarArticlesApiParameter, BlogSimilarArticlesCollectionModel>;

export const PopulateApiParameter: HandlerType = props => {
    props.apiParameter = { ...props.parameter, type: constants.blog.getDataViewType.similarArticles } as any; // 'type' is neccessary to differentiate dataView (cache) keys
};

export const DispatchBeginLoadBlogSimilarArticles: HandlerType = props => {
    props.dispatch({
        type: "Data/Pages/BeginLoadPages",
        parameter: props.apiParameter as any,
    });
};

export const RequestDataFromApi: HandlerType = async props => {
    props.apiResult = await getBlogSimilarArticles(props.apiParameter);
};

export const DispatchCompleteLoadBlogSimilarArticles: HandlerType = props => {
    const state = props.getState();

    props.dispatch({
        type: "Data/Pages/CompleteLoadPages",
        parameter: props.apiParameter as any,
        collection: {
            pages: props.apiResult.pages,
            pagination: {} as any,
        },
        links: state.links,
        ...getContextData(state),
    });
};

export const chain = [
    PopulateApiParameter,
    DispatchBeginLoadBlogSimilarArticles,
    RequestDataFromApi,
    DispatchCompleteLoadBlogSimilarArticles,
];

const loadBlogSimilarArticles = createHandlerChainRunner(chain, "LoadBlogSimilarArticles");
export default loadBlogSimilarArticles;
